import Preset from './_default';

export default class Brooklyn extends Preset {
    name = 'Simple';

    // override the default Preset here
}
